<template>
  <span
    :class="
      device.signalStrength < 20 && device.signalStrength != null
        ? 'text-danger'
        : ''
    "
  >
    <div class="atom-icon">
      <img
        v-if="device.signalStrength == null"
        src="@/assets/icons/signal/ico/sila-rssi-na.svg"
        width="24"
      />
      <img
        v-else-if="device.signalStrength >= 81"
        src="@/assets/icons/signal/ico/sila-rssi-01.svg"
        width="24"
      />
      <img
        v-else-if="device.signalStrength < 81 && device.signalStrength >= 65"
        src="@/assets/icons/signal/ico/sila-rssi-02.svg"
        width="24"
      />
      <img
        v-else-if="device.signalStrength < 65 && device.signalStrength >= 40"
        src="@/assets/icons/signal/ico/sila-rssi-03.svg"
        width="24"
      />
      <img
        v-else-if="device.signalStrength < 40 && device.signalStrength >= 20"
        src="@/assets/icons/signal/ico/sila-rssi-04.svg"
        width="24"
      />
      <img
        v-else-if="device.signalStrength < 20 && device.signalStrength != null"
        src="@/assets/icons/signal/ico/sila-rssi-05.svg"
        width="24"
      />
    </div>
  </span>
</template>

<script>
export default {
  props: {
    device: Object
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
